import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ResponsableTipoSelect from "./ResponsableTipoSelect.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa: null,
            tipo: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa: data.empresa_id,
            tipo: data.tipo_id,
        });
        
    }
    render() {
        return (
            <ParadigmaModal
                getUrl={api.clientes.responsables.delete}
                postUrl={api.clientes.responsables.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Contacto ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Contacto"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                buttonTitle={"Eliminar Contacto"}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-6">
                        <Label>Nombre</Label>
                        <Input disabled={true} type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Apellido</Label>
                        <Input disabled={true} type="text" name="apellido"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Empresa</Label>
                        <ParadigmaAsyncSeeker disabled={true} fieldName={"empresa_id"} url={api.clientes.empresas.select} value={this.state.empresa} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-8">
                        <Label>Tipo</Label>
                        <ParadigmaAsyncSeeker disabled={true} value={this.state.tipo} fieldName={"tipo_id"} multiselect={true} url={api.clientes.tiporesponsables.select}/>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                        <Input disabled={true} type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Email</Label>
                        <Input disabled={true} type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input disabled={true} type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/clientes/Responsables/Delete.js